import * as Actions from '../actions';

const initialState = {};

export default function courseSources(state = initialState, action) {
  switch (action.type) {
    case Actions.LOAD_COURSE_SOURCES:
      return {
        ...state,
        [action.courseId]: action.sources,
      };
    default:
      return state;
  }
}
